export default function resetSelectedOptions({ state }) {
  const {
    registrating: { current }
  } = state.get('client')
  Object.keys(current).forEach(form => {
    Object.keys(current[form]).forEach(fieldKey => {
      let field = current[form][fieldKey]
      if (field.type === 'select') {
        if (field.query) {
          state.unset(`client.registrating.current.${form}.${fieldKey}.query`)
          state.unset(
            `client.registrating.current.${form}.${fieldKey}.filteredOptions`
          )
        }
      }
      if (field.type === 'select' && field.options.length > 0) {
        let selectedIndex = null
        if (field.defaultValue.length > 0) {
          selectedIndex = field.defaultValue[0].index
        }
        let options = field.options.map(option => {
          return {
            ...option,
            selected: selectedIndex === option.index || false
          }
        })
        state.set(
          `client.registrating.current.${form}.${fieldKey}.options`,
          options
        )
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/modules/user/actions/resetSelectedOptions.js